import { render } from "./RouterManager.vue?vue&type=template&id=f623953c"
import script from "./RouterManager.vue?vue&type=script&lang=js"
export * from "./RouterManager.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__